import { makeStyles } from '@material-ui/core';

export default makeStyles({
  template: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
  },
});
